import { createContext } from 'react';

type MutexStore = string[];

export const MutexContext = createContext<MutexStore>([]);
